'use client';

import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

/**
 * Returns `false` during server rendering and the initial hydration pass, then
 * `true` once mounted on the client. Use this instead of the
 * `useState(false)` + `useEffect(() => setState(true))` pattern  - it produces
 * the same behaviour without the setState-in-effect cascading render.
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  );
}
